import React from 'react'
import { WithErrorBoundary } from '../common/ErrorBoundary'

const MainComparador = WithErrorBoundary(
  'Comparador',
  'Error en Comparador',
  React.lazy(() => import('./MainComparador')),
)

export default {
  path: '/comparador',
  name: 'Comparador',
  childRoutes: [{ path: '', name: 'Main comparador', component: MainComparador, isIndex: true }],
}
